/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

interface IEtiquetas {
  descricao: string;
  uuid: string;
  ref: string;
  validade: string;
}

const EtiquetasGrand = async (dados: IEtiquetas[]) => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const colunasPorLinha = 2;
  const tabelaEtiquetas: any[] = [];

  const etiquetasProcessadas = await Promise.all(
    dados.map(async (item) => {
      return {
        stack: [
          {
            text: item.descricao,
            margin: [0, 8, 30, 0],
            fontSize: 12,
            alignment: 'center',
          },
          {
            qr: `${item.uuid};${item.descricao};${item.ref};${item.validade}`,
            fit: '160',
            alignment: 'center',
            border: [false, false, false, false],    
            margin: [10, 0, 13, 0],
            // [left, top, right, bottom]
          },
          { text: item.validade, fontSize: 8, alignment: 'center' },
        ],       
        margin: [0, 0, 0, 0],
        border: [false, false, false, false],
      };
    }),
  );

  // Agrupa as etiquetas em linhas com 3 colunas
  for (let i = 0; i < etiquetasProcessadas.length; i += colunasPorLinha) {
    tabelaEtiquetas.push(etiquetasProcessadas.slice(i, i + colunasPorLinha));
  }

  const docDefinition: any = {
    pageSize: { width: 370, height: 170},
    pageMargins: [0, 0, 0, 0],
    pageOrientation: 'landscape',
    content: [
      {
        table: {
          widths: Array(colunasPorLinha).fill('*'), // Define colunas de tamanhos iguais
          // widths: [larguraEtiqueta, larguraEtiqueta, larguraEtiqueta],
          body: tabelaEtiquetas,
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(docDefinition);
  pdfDocGenerator.open();
};

export default EtiquetasGrand;
